<template>
  <fn-modal
    full-screen-mobile
    class="modal-product-info"
    max-width="m"
    keep-scroll-position
    @close="$emit('close')"
  >
    <template v-if="marketplaceModal">
      <fn-headline
        type="h2"
        size="h3"
        icon="marketplace"
      >
        {{ $t('shipping.marketplaceModal.headline') }}
      </fn-headline>

      <fn-paragraph
        v-for="index in 3"
        :key="index"
      >
        {{ $t(`shipping.marketplaceModal.paragraph${index}`) }}
      </fn-paragraph>
    </template>

    <template v-if="clickAndCollectModal">
      <fn-headline
        type="h2"
        size="h3"
        icon="store-new"
      >
        {{ $t('shipping.clickAndCollectModal.headline') }}
      </fn-headline>

      <div v-html="$t('shipping.clickAndCollectModal.paragraph1')" />

      <fn-link
        class="mpi-link"
        :to="$t('shipping.clickAndCollectModal.link.url')"
        no-arrow
        underline
      >
        {{ $t('shipping.clickAndCollectModal.link.text') }}
      </fn-link>
    </template>

    <fn-button
      secondary
      full-width
      @click="$emit('close')"
    >
      {{ $t('buttons.accept') }}
    </fn-button>
  </fn-modal>
</template>

<script setup lang="ts">
defineProps({
  marketplaceModal: {
    type: Boolean,
  },
  clickAndCollectModal: {
    type: Boolean,
  },
});

defineEmits(['close']);
</script>

<style lang="scss" scoped>
.modal-product-info {
  flex: 0 0 auto;

  :deep(.m-actions) {
    border-bottom: 0;
  }

  :deep(.m-content) {
    padding-top: 0;
  }

  :deep(.heading .icon) {
    color: $color-brand-fnmz-green;
  }

  .mpi-link {
    display: block;
    margin: $pad 0;
    font-size: map-get($font-sizes, l);
  }
}
</style>
